import availableHairColors from '../../../../../../../../../helpers/hairColorHelper'
import availableEthnicities from '../../../../../../../../../helpers/ethnicityHelper'
import { availableCastingJobTypes } from '../../../../../../../../../helpers/availableJobTypeHelper'
import availableSizes from '../../../../../../../../../helpers/sizeHelper'
import availableShirtSizes from '../../../../../../../../../helpers/shirtSizeHelper'
import pastJob from '../../../../../dto/pastJobs'
import media from '../../../../../dto/media'

export default function() {
    let medias = []
    for (let i = 1; i <= 4; i++) {
        let photo = Object.assign({}, media)
        photo.type = 'photo'

        medias.push(photo)
    }
    let video = Object.assign({}, media)
    video.type = 'video'
    medias.push(video)

    return {
        availableHairColors,
        availableEthnicities,
        availableCastingJobTypes,
        availableSizes,
        availableShirtSizes,
        isExpanded: null,
        profile: {
            category: 'casting',
            height: null,
            shirtSize: null,
            size: null,
            shoesSize: null,
            bust: null,
            waist: null,
            hip: null,
            hairColor: null,
            ethnicity: null,
            fees: [],
            pastJobs: [{...pastJob}],
            media: medias,
            types: []
        },
        errors: {
            height: null,
            shirtSize: null,
            size: null,
            shoesSize: null,
            hairColor: null,
            ethnicity: null,
            types: null,
            pastJobs: []
        },
        showCropper: false,
        showVideoInput: false,
        videoObj: null,
        croppingImage: null,
        videoError: null
    }
}
